import { useContext, FC, useState } from 'react'
import PatchNotesContext, { PatchNotesType } from './Context'

type Props = {
  children: JSX.Element
}

const PatchNotesProvider: FC<Props> = ({ children }) => {
  const [categoriesFilters, setCategoriesFilters] = useState({
    ADJUSTMENTS: true,
    ADVERTISEMENT: true,
    FEATURE: true,
    FIX: true,
  })
  const [modulesFilters, setModulesFilters] = useState({
    ACTIVITIES: true,
    APP_CITIZEN: true,
    ASSESSMENTS_AND_RESEARCH: true,
    ATTENDANCES: true,
    CITIZEN_PORTAL: true,
    CITIZEN_PROFILE: true,
    DATA_INTEGRATOR: true,
    DIGITAL_ARCHIVE: true,
    GEO: true,
    INSTITUTIONAL_MANAGEMENT: true,
    INVENTORY: true,
    MESSENGER: true,
    OBSERVATORY: true,
    PROCESSES_AND_DOCUMENTS: true,
    REGULATION: true,
    SCHEDULES: true,
    SERVICES_LETTER: true,
    UNIFIED_LOGIN: true,
    VULNERABILITY_ALERTS: true,
    GENERAL: true,
  })

  return (
    <PatchNotesContext.Provider value={{ categoriesFilters, setCategoriesFilters, modulesFilters, setModulesFilters }}>
      {children}
    </PatchNotesContext.Provider>
  )
}

export default PatchNotesProvider

export const usePatchNotes = () => useContext<PatchNotesType>(PatchNotesContext)
